<template>
  <!-- 红包雨 --><!-- 裂变神券 --><!-- 评价有礼 -->
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <img
        class="pointer"
        @click="clickLocalStep()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="1">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep">
        <div class="card-point" v-if="activityData.id != 22">
          <template v-if="activityData.id == 20">
            <div class="card-rule">注意：</div>
            <div class="card-connet">
              <p>
                1、因淘宝平台规定:消费者可对60天内购买的商品进行评价,故软件拉取近60天内评价状态可参与活动；<a
                  style="color: #fe4d45"
                  class="pointer"
                  href="https://rule.jd.com/rule/ruleDetail.action?ruleId=4285"
                  target="_blank"
                  >查看平台规则</a
                >
              </p>
              <p>
                2、单个订单中包含几款商品则可获几次抽奖机会，虚拟商品无法获得抽奖机会；
              </p>
              <p>
                3、因淘宝系统需要对评价和晒单内容进行审核,如果客户没有获得参与活动机会,需要通过商家后台核实客户的评论状态;
              </p>
            </div>
          </template>
          <template v-if="activityData.id == 21">
            <div class="card-rule"></div>
            <div class="card-connet">
              <p>商家须知</p>
              <p>
                1、为避免因奖品发完活动提前结束引起客诉，请仔细核对当前活动内容与活动规则设置，明确活动成本预算
              </p>
              <p>
                2、为避免修改成团条件导致客诉，活动创建后成团条件将不可修改，请在创建时仔细核对
              </p>
              <p>3、活动期间每个用户，同一优惠最多获得一次</p>
            </div>
          </template>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="backgroundForm"
          label-width="120px"
        >
          <el-form-item label="活动名称:" required>
            <!-- prop="activityName" 活动名称 -->
            <el-input
              v-model="ruleForm.activityName"
              maxlength="50"
              show-word-limit
              placeholder="请填入活动名称"
              style="width: 340px"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动时间:" required>
            <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
            <div class="my_select_time">
              <el-date-picker
                v-model="activityTimeValue"
                type="datetimerange"
                class="rangeTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ref="timeBox"
                @change="activityTimeChange"
                :disabled="!isSave && activityData.id == 20"
                style="width: 340px; font-size: 12px"
                :picker-options="pickerOptionsValue"
                :default-time="defaultTime"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="activityTimeValue = []"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天
              <span style="color: #2670fb">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动有效期不可超过订购有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>
          <el-form-item label="活动对象：" required>
            <el-radio-group
              v-model="ruleForm.activityObject"
              :disabled="isStartEdit"
              @change="handleActivityObj"
              style="margin-right: 16px"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">指定身份</el-radio>
              <el-radio :label="2" disabled>指定人群</el-radio>
            </el-radio-group>
            <el-popover
              placement="right-start"
              trigger="hover"
              content="您不满足使用该功能的条件，请联系专属客服了解~"
            >
              <el-button slot="reference" disabled>{{
                peopleList.length == 0
                  ? "选择人群"
                  : `已选${peopleList.length}个`
              }}</el-button>
            </el-popover>
          </el-form-item>
          <el-form-item
            label="新老客户："
            required
            v-if="ruleForm.activityObject == '1'"
          >
            <el-radio-group
              v-model="ruleForm.newOldCustomer"
              :disabled="isStartEdit"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">新客</el-radio>
              <el-radio :label="2">老客</el-radio>
            </el-radio-group>
            <el-tooltip effect="dark" placement="top-start">
              <div slot="content">
                1、历史订单中已完成订单的订单数为0则定义为新客<br />2、历史订单中已完成订单的订单数≥1则定义为新客
              </div>
              <div
                class="cursorPointer"
                style="
                  display: inline-block;
                  margin-left: 16px;
                  font-size: 12px;
                  color: #999;
                "
              >
                <span>新老客说明</span>
                <i class="el-icon-question"></i>
              </div>
            </el-tooltip>
          </el-form-item>
          <el-form-item
            label="参与对象:"
            prop="partner"
            v-if="ruleForm.activityObject == '1'"
          >
            <el-checkbox-group
              v-model="ruleForm.partner"
              @change="checkListchange"
              :disabled="isStartEdit"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox
                label="0"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >非会员</el-checkbox
              >

              <el-checkbox
                v-for="(item, index) in levelList"
                :key="index"
                :label="index + 1 + ''"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            label="入会时间:"
            v-if="ruleForm.activityObject == '1' && ruleForm.partner != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="
              nowType == 'look' ||
              (nowType == 'edit' && activityData.status == 2)
            "
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>
          <el-form-item label="活动条件:" v-if="activityData.id != 21">
            <el-checkbox :disabled="isStartEdit" v-model="ruleForm.condFollow"
              >关注店铺后方可参与活动</el-checkbox
            ></el-form-item
          >
          <!-- 红包雨 -->
          <template v-if="activityData.id == 22">
            <el-form-item label="游戏时间:" required>
              <el-input
                :disabled="isStartEdit"
                v-model="ruleForm.gameTime"
                maxlength="3"
                @input="ruleForm.gameTime = getNumberData($event, 0)"
                style="width: 70px"
                placeholder="请输入"
              ></el-input>
              秒倒计时
              <el-tooltip
                class="item"
                effect="light"
                style="color: #ccc !important"
                content="红包掉落总个数=游戏时间*3"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="奖项设置:" required>
              <el-table
                :data="awardSettingsLsit"
                style="width: 100%; border: 1px solid #eeeeee; margin-top: 15px"
                :header-cell-style="{
                  background: '#F8F9FF',
                  'text-align': 'left',
                }"
                :cell-style="{ 'text-align': 'left' }"
              >
                <el-table-column label="奖项级别" width="100">
                  <template slot-scope="scope">
                    <span>{{ (scope.$index + 1) | toChinesNum }}等奖</span>
                  </template>
                </el-table-column>
                <el-table-column label="选择奖品">
                  <template slot-scope="scope">
                    <span
                      class="s"
                      @click="selectPacket(scope.$index, scope.row)"
                      >选奖品</span
                    >
                  </template>
                </el-table-column>

                <el-table-column label="奖品类型">
                  <template slot-scope="scope">
                    <span>{{ scope.row.prizeType | prizeType }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="值"
                  width="80"
                  prop="price"
                ></el-table-column>
                <el-table-column label="奖品名称（12字内）" width="299">
                  <template slot-scope="scope">
                    <el-input
                      :disabled="isStartEdit"
                      v-model="scope.row.title"
                      maxlength="12"
                      show-word-limit
                      style="width: 240px"
                      placeholder="请输入"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="奖品总数" width="200">
                  <template slot-scope="scope">
                    <el-input
                      @blur="beAdd(scope.row)"
                      v-model="scope.row.totalAmount"
                      @input="scope.row.totalAmount = getNumberData($event, 0)"
                      maxlength="10"
                      class="inputcount"
                      show-word-limit
                      style="width: 150px"
                      placeholder="请输入"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="260">
                  <template slot="header">
                    <span>获奖条件</span>
                    <el-popover
                      placement="top-start"
                      offset="100"
                      trigger="hover"
                      content="每个红包分值为10分，请合理分配；"
                    >
                      <span slot="reference">
                        <p class="question_icon">!</p>
                      </span>
                    </el-popover>
                  </template>
                  <template slot-scope="scope">
                    <el-input
                      :disabled="isStartEdit"
                      v-model.number="scope.row.awardMinScore"
                      @change="scoreChange(scope.row, scope.$index)"
                      placeholder="请输入"
                      style="width: 80px; margin-right: 5px"
                      @input="
                        scope.row.awardMinScore = getNumberData($event, 0)
                      "
                    ></el-input
                    >分 ~
                    <el-input
                      :disabled="isStartEdit"
                      v-model.number="scope.row.awardMaxScore"
                      @change="scoreChange(scope.row, scope.$index)"
                      placeholder="请输入"
                      style="width: 80px; margin-right: 5px"
                      @input="
                        scope.row.awardMaxScore = getNumberData($event, 0)
                      "
                    ></el-input
                    >分
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <span
                      class="s"
                      style="color: #f56c6c; margin-right: 10px"
                      @click="deletePacket(scope.row, '1')"
                      >清空</span
                    >
                    <span
                      v-show="scope.$index != 0"
                      class="s"
                      style="color: #f56c6c"
                      @click="deletePacket(scope.$index)"
                      >删除</span
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div @click="addPacket" class="add_btn1">
                <!-- <img style="width:24px" src="../../assets/images/add.svg" alt="" /> -->
                增加奖项
              </div>
            </el-form-item>
            <el-form-item label="中奖限制:">
              活动期间每人每天中奖不超过&nbsp;<el-input
                :disabled="isStartEdit"
                @input="ruleForm.everyoneWinningNum = getNumberData($event, 0)"
                style="width: 60px"
                @change="orderChange"
                v-model="ruleForm.everyoneWinningNum"
                placeholder="请输入"
              ></el-input
              >&nbsp; 次，累计中奖不超过&nbsp;
              <el-input
                :disabled="isStartEdit"
                @input="ruleForm.winningNum = getNumberData($event, 0)"
                @change="orderChange"
                style="width: 60px"
                v-model="ruleForm.winningNum"
                placeholder="请输入"
              ></el-input
              >&nbsp; 次，奖品有限，先到先得
            </el-form-item>
          </template>
          <!-- 裂变神券 -->
          <template v-if="activityData.id == 21">
            <el-form-item label="奖项设置:" required>
              <div class="rule_box" style="width: 100%">
                <div class="rule_box_middle">
                  <div class="rule_box_content">
                    <i
                      class="el-alert__icon el-icon-info"
                      style="color: #2670fb"
                    ></i>
                    <span style="margin-left: 3px">创建活动请注意以下几点</span>
                    <p>
                      1、设置活动的各个奖项，请尽量确保一个活动中的各个奖项的份数一致，避免某个奖项提前领取完，导致用户看到奖项但无法领取而客诉；
                    </p>
                    <p>
                      2、如果券是指定会员等级的用户才可领取，建议您在创建优惠券时选择品牌会员券，勾选相应的会员等级，并与活动设置会员等级保持一致，降低客诉与盗刷风险；
                    </p>
                    <p>
                      3、请提前预估活动流量，如流量过大，请至少提前1天联系客服进行报备，以免大流量导致活动异常。
                    </p>
                  </div>
                </div>
              </div>

              <el-table
                :data="FissionVoucherList"
                style="width: 100%; border: 1px solid #eeeeee; margin-top: 15px"
                :header-cell-style="{
                  background: '#F8F9FF',
                  'text-align': 'left',
                }"
                :cell-style="{ 'text-align': 'left' }"
              >
                <el-table-column label="优惠券名称">
                  <template slot-scope="scope">
                    <span
                      class="s"
                      style="color: #2670fb"
                      @click="selectCoupon(scope.$index)"
                      >{{
                        scope.row.title ? scope.row.title : "选择优惠券"
                      }}</span
                    >
                  </template>
                </el-table-column>

                <el-table-column label="面额">
                  <template slot-scope="scope">
                    {{ scope.row.price ? scope.row.price + "元" : "" }}
                  </template>
                </el-table-column>
                <el-table-column label="使用条件">
                  <template slot-scope="scope">
                    {{
                      scope.row.conditions
                        ? "满" + scope.row.conditions + "可用"
                        : scope.row.conditions == 0 && scope.row.price
                        ? "满0可用"
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column min-width="180" max-width="250">
                  <template slot="header">
                    <span>组队人数</span>
                    <el-popover
                      placement="top-start"
                      offset="100"
                      trigger="hover"
                      content="成团人数大于1，活动生效后不可更改；"
                    >
                      <span slot="reference">
                        <p class="question_icon">!</p>
                      </span>
                    </el-popover>
                  </template>
                  <template slot-scope="scope">
                    <el-input
                      :disabled="isStartEdit"
                      v-model.number="scope.row.groupNums"
                      placeholder="请输入组队人数"
                      style="width: 120px"
                      @change="
                        multiple(
                          scope.row.groupNums,
                          scope.row.totalAmount,
                          scope.$index
                        )
                      "
                      @input="scope.row.groupNums = checkputn($event, '5')"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column min-width="180" max-width="250">
                  <template slot="header">
                    <span>发放数量</span>
                    <el-popover
                      placement="top-start"
                      offset="100"
                      trigger="hover"
                      content="发放数量必须为组队人数的N倍，以确保奖品发放顺利；"
                    >
                      <span slot="reference">
                        <p class="question_icon">!</p>
                      </span>
                    </el-popover>
                  </template>
                  <template slot-scope="scope">
                    <!-- @blur="beAdd(scope.row)" -->
                    <el-input
                      v-model="scope.row.totalAmount"
                      placeholder="请输入发放数量"
                      style="width: 120px"
                      @change="
                        multiple(
                          scope.row.groupNums,
                          scope.row.totalAmount,
                          scope.$index,
                          scope.row
                        )
                      "
                      @input="scope.row.totalAmount = getNumberData($event, 0)"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <span
                      class="s"
                      style="color: #f56c6c; margin-right: 10px"
                      @click="deleteaCoupon(scope.row, '1')"
                      >清空</span
                    >
                    <span
                      v-show="scope.$index != 0"
                      class="s"
                      style="color: #f56c6c"
                      @click="deleteaCoupon(scope.$index)"
                      >删除</span
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div @click="addCoupon" class="add_btn1">添加优惠券</div>
            </el-form-item>
          </template>
          <!-- 评价有礼 -->
          <template v-if="activityData.id == 20">
            <el-form-item label="条件设置:" required>
              <div class="rule_box">
                <div class="rule_box_middle">
                  <el-form-item label="评价时间:" required>
                    <el-select
                      v-model="appraiseValue"
                      placeholder="请选择"
                      :disabled="!isSave"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <div
                      style="margin-left: 10px"
                      class="my_select_time"
                      v-if="appraiseValue === '0'"
                    >
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleForm.startCommentTime"
                        type="datetime"
                        placeholder="开始日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 190px; font-size: 12px"
                        default-time="00:00:00"
                        class="time1"
                        @change="orderChange"
                        :clearable="false"
                        :picker-options="pickerOrderStart"
                        :disabled="!isSave"
                      >
                      </el-date-picker>
                      <div class="time_to_text">至</div>
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleForm.endCommentTime"
                        type="datetime"
                        placeholder="结束日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 195px; font-size: 12px"
                        default-time="23:59:59"
                        class="time2"
                        @change="orderChange"
                        :clearable="false"
                        :picker-options="pickerOrderEnd"
                        :disabled="!isSave"
                      >
                      </el-date-picker>
                      <i
                        class="el-icon-circle-close date_icon1"
                        @click="clearOrderTime()"
                      ></i>
                      <img
                        src="@/assets/images/select_date.svg"
                        alt=""
                        class="date_icon2"
                      />
                    </div>
                  </el-form-item>

                  <el-form-item label="参与商品:" required class="zindexBox">
                    <el-radio
                      v-model="ruleForm.filterType"
                      label="0"
                      :disabled="!isSave"
                      >全部商品</el-radio
                    >
                    <el-radio
                      v-model="ruleForm.filterType"
                      label="1"
                      :disabled="!isSave"
                      >指定商品</el-radio
                    >
                    <el-button
                      :disabled="ruleForm.filterType == 0 || !isSave"
                      :style="{
                        width: itemListForFilter.length > 0 ? '110px' : '60px',
                      }"
                      @click="exposureProductsFiter"
                    >
                      {{
                        itemListForFilter.length != ""
                          ? "已选择" + "(" + itemListForFilter.length + "个)"
                          : "+添加"
                      }}
                    </el-button>
                    <draggable
                      v-if="itemListForFilter.length > 0"
                      v-model="mainImagelistFilter"
                      chosen-class="chosen"
                      :scroll="true"
                      animation="150"
                      force-fallback="true"
                      @start="isDraggingFilter = true"
                      @end="onEndFilter"
                      style="
                        margin-top: 10px;
                        background: rgba(38, 112, 251, 0.06);
                        padding: 10px 10px 0px 10px;
                      "
                    >
                      <transition-group type="transition">
                        <div
                          v-for="(item, index) in mainImagelistFilter"
                          :key="item.skuId"
                          style="display: inline-block; position: relative"
                          class="show_upImg2"
                        >
                          <img
                            :src="item.logo"
                            width="120px"
                            height="120px"
                            style="display: inline-block"
                          />&nbsp;
                          <!-- <div  class="delectPosible">
                            <i class="el-icon-circle-close" style="font-size: 16px"></i>
                          </div> -->
                          <div v-if="!isSave" class="delectPosible">
                            <span class="delectSort">拖动排序</span>
                            <img
                              src="@/assets/thdImg/pages/delet.svg"
                              class="delectIcom"
                            />
                          </div>
                          <div v-else class="delectPosible">
                            <span class="delectSort">拖动排序</span>
                            <img
                              src="@/assets/thdImg/pages/delet.svg"
                              @click.stop="delecFilter(item, index)"
                              class="delectIcom"
                            />
                          </div>
                          <!-- <div  @click.stop="delecFilter(index)" class="delectPosible">
                            <i class="el-icon-circle-close" style="font-size: 16px"></i>
                          </div> -->
                        </div>
                      </transition-group>
                    </draggable>
                  </el-form-item>

                  <el-form-item label="评星设置:" required>
                    <el-checkbox-group v-model="scores">
                      <el-checkbox
                        v-for="item in labelVal"
                        :label="item.value"
                        :key="item.value"
                        :disabled="!isSave"
                        >{{ item.name }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </el-form-item>

                  <el-form-item label="评价字数:">
                    评价至少
                    <el-input
                      :disabled="!isSave"
                      v-model="ruleForm.wordNum"
                      @input="ruleForm.wordNum = getNumberData($event, 0)"
                      style="width: 140px"
                      placeholder="请输入"
                    ></el-input>
                    个字（空或0表示不限制）
                  </el-form-item>
                  <el-form-item label="评价图片:">
                    包含至少
                    <el-input
                      :disabled="!isSave"
                      v-model="ruleForm.imgNum"
                      @input="ruleForm.imgNum = checkputn($event, '1')"
                      style="width: 140px"
                      placeholder="请输入"
                    ></el-input>
                    张图片（空或0表示不限制，不超过9）
                  </el-form-item>
                  <el-form-item label="评价视频:">
                    包含至少
                    <el-input
                      :disabled="ruleForm.imgNum == 9 || !isSave"
                      v-model="ruleForm.videoNum"
                      @input="ruleForm.videoNum = checkputn($event, '2')"
                      style="width: 140px"
                      placeholder="请输入"
                    ></el-input>
                    段视频（空或0表示不限制，不超过1）
                    <div style="color: red">
                      注意：图片数量+视频数量总数必须=<9
                    </div>
                  </el-form-item>
                  <el-form-item label="过滤条件:">
                    <el-checkbox
                      v-model="ruleForm.isCommentFilter"
                      :disabled="!isSave"
                      >评价内容包含</el-checkbox
                    >&nbsp;
                    <el-input
                      :disabled="!isSave"
                      v-model="ruleForm.commentFilter"
                      @input.native="
                        ruleForm.commentFilter = ruleForm.commentFilter.replace(
                          /，/g,
                          ','
                        )
                      "
                      style="width: 200px"
                      placeholder="多个关键词之间用英文“,”隔开"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="中奖限制:">
              活动期间每人每天中奖不超过&nbsp;<el-input
                @input="
                  ruleForm.oneDayMaxRewardNumber = getNumberData($event, 0)
                "
                @change="orderChange"
                style="width: 60px"
                v-model="ruleForm.oneDayMaxRewardNumber"
                placeholder="请输入"
                :disabled="!isSave"
              ></el-input
              >&nbsp; 次，累计中奖不超过
              <el-input
                @input="
                  ruleForm.totalMaxRewardNumber = getNumberData($event, 0)
                "
                @change="orderChange"
                style="width: 60px"
                v-model="ruleForm.totalMaxRewardNumber"
                placeholder="请输入"
                :disabled="!isSave"
              ></el-input>
              次
            </el-form-item>
            <el-form-item required>
              <span slot="label" class="set">奖品设置:</span>
              <div class="termAdd">
                <el-popover placement="right" width="270" trigger="hover">
                  <img
                    src="../../assets/images/integralCenter/wzsyt.png"
                    alt=""
                  />
                  <span slot="reference">位置示意图</span>
                </el-popover>
                <p>
                  累计中奖率: <span class="add">{{ winningRate }} %</span>
                </p>
              </div>
              <el-table
                :data="prizeSettingList"
                style="width: 100%; border: 1px solid #f0f0f0"
                :header-cell-style="{
                  background: '#fafafa',
                  'text-align': 'left',
                }"
                :cell-style="{ 'text-align': 'left' }"
              >
                <el-table-column label="位置">
                  <template slot-scope="scope">
                    <span v-if="scope.row.index == 0">一</span>
                    <span v-if="scope.row.index == 1">二</span>
                    <span v-if="scope.row.index == 2">三</span>
                    <span v-if="scope.row.index == 3">四</span>
                    <span v-if="scope.row.index == 4">五</span>
                    <span v-if="scope.row.index == 5">六</span>
                    <span v-if="scope.row.index == 6">七</span>
                    <span v-if="scope.row.index == 7">八</span>
                  </template>
                </el-table-column>

                <el-table-column label="选择奖品">
                  <template slot-scope="scope">
                    <span v-if="!isSave" class="s">选奖品</span>
                    <span v-else class="s" @click="centerVis(scope.row)"
                      >选奖品</span
                    >
                  </template>
                </el-table-column>

                <el-table-column label="奖品类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.prizeType == 1">优惠券</span>
                    <span v-if="scope.row.prizeType == 2">京豆</span>
                    <span v-if="scope.row.prizeType == 3">实物</span>
                    <span v-if="scope.row.prizeType == 4">店铺积分</span>
                    <span v-if="scope.row.prizeType == 5">淘宝E卡</span>
                    <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                    <span v-if="scope.row.prizeType == 7">淘宝PLUS会员</span>
                    <span v-if="scope.row.prizeType == 8">现金红包</span>
                    <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                    <span v-if="scope.row.prizeType == 10">专属商品</span>
                  </template>
                </el-table-column>

                <el-table-column label="值" width="80" prop="price">
                </el-table-column>

                <el-table-column label="奖品名称（12字内）" width="299">
                  <template slot-scope="scope">
                    <el-input
                      :disabled="!isSave"
                      v-model="scope.row.title"
                      maxlength="12"
                      show-word-limit
                      style="width: 240px"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="奖品总数" width="180">
                  <template slot-scope="scope">
                    <el-input
                      :disabled="!isSave"
                      v-model.number="scope.row.totalAmount"
                      placeholder="请输入..."
                      style="width: 70px"
                      @input="scope.row.totalAmount = getNumberData($event, 0)"
                    ></el-input>
                    份
                  </template>
                </el-table-column>

                <el-table-column label="中奖率">
                  <template slot-scope="scope">
                    <el-input
                      :disabled="!isSave"
                      v-model="scope.row.percentage"
                      placeholder="请输入..."
                      style="width: 70px"
                      @keyup.native="
                        scope.row.percentage = oninput2(scope.row.percentage)
                      "
                      @input="
                        scope.row.percentage = getNumberData($event, 1, 0, 100)
                      "
                    ></el-input>
                    %
                  </template>
                </el-table-column>

                <el-table-column label="图片" width="170">
                  <template slot-scope="scope">
                    <img
                      v-if="scope.row.logo"
                      :src="scope.row.logo"
                      style="width: 56px; height: 56px"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <span v-if="!isSave" class="s">清除</span>
                    <span v-else class="s" @click="cleanData(scope.row)"
                      >清除</span
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div class="tips">
                <img src="@/assets/images/new_icon_reminder.png" />
                <span style="margin-left: 21px"> 说明</span>
                <p>
                  1、最多设置8个奖项；设置的奖项不足8个时，系统自动补充“谢谢参与”
                </p>
                <p>
                  2、中奖率相加不得超过100%，不足100%的时候剩余部分分配给“谢谢参与”
                </p>
                <p>3、中奖率精确到小数点后三位，如不想中奖可设置0%</p>
                <p>
                  4、实物奖品可上传图片，不上传使用默认图片。已有图片时点击可更换。
                </p>
              </div>
            </el-form-item>
          </template>
          <el-form-item label="曝光商品:" class="zindexBox">
            <el-checkbox
              v-model="ruleForm.exposureSwitch"
              @change="exposureSwitchChange"
              :disabled="!isSave"
            >
              是否添加曝光商品
            </el-checkbox>
            <el-button
              style="width: 155px; margin: 0 15px"
              @click="exposureProducts"
              :disabled="
                ruleForm.exposureSwitch == false ||
                (!isSave && activityData.id == 20)
              "
            >
              {{
                itemListFor.length != ""
                  ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                  : "添加曝光商品"
              }}
            </el-button>
            <!-- <el-radio-group v-model="ruleForm.radio" :disabled="ruleForm.exposureSwitch == false || (!isSave && activityData.id == 20)">
              <el-radio :label="0">显示淘宝价</el-radio>
              <el-radio :label="1">显示促销价</el-radio>
            </el-radio-group> -->
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="
                margin-top: 10px;
                background: rgba(38, 112, 251, 0.06);
                padding: 10px 10px 0px 10px;
              "
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <!-- <div v-if="!isSave && activityData.id == 20" class="delectPosible">
                    <i class="el-icon-circle-close" style="font-size: 16px"></i>
                  </div>
                  <div v-else @click.stop="delec(index)" class="delectPosible">
                    <i class="el-icon-circle-close" style="font-size: 16px"></i>
                  </div> -->
                  <div
                    v-if="!isSave && activityData.id == 20"
                    class="delectPosible"
                  >
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      class="delectIcom"
                    />
                  </div>
                  <div v-else class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      @click.stop="delec(item, index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>
          <el-form-item label="活动规则:" required>
            <div
              style="
                width: 500px;
                backgroundcolor: rgba(250, 250, 250, 1);
                padding: 8px;
                position: relative;
              "
            >
              <el-input
                type="textarea"
                class="textarea"
                style="width: 484px"
                resize="none"
                v-model="ruleForm.activityRulesText"
                :maxlength="2000"
                :disabled="backgroundOpacity"
              ></el-input>
              <div class="prosi" style="color: #909399">
                （{{
                  ruleForm.activityRulesText.length
                    ? ruleForm.activityRulesText.length
                    : 0
                }}/2000）
              </div>
              <div>
                <el-button
                  type="primary"
                  class="generate"
                  plain
                  @click="generateRule"
                  :disabled="backgroundOpacity"
                >
                  生成规则
                </el-button>

                <span class="desc">
                  <i
                    class="el-alert__icon el-icon-info"
                    style="color: #999"
                  ></i>
                  点击按钮自动生成规则，也可以自己编辑信息
                </span>
              </div>
            </div>
          </el-form-item>
          <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <el-button
        v-show="!itemId"
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <template v-if="!backgroundOpacity">
        <el-button
          v-show="!itemId"
          v-if="isSave"
          class="createBtn create_bottom_keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存设置</el-button
        >
      </template>
      <el-button
        v-show="itemId"
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="cancelEdit"
        >取消</el-button
      >
      <el-button
        v-show="itemId"
        class="createBtn create_bottom_keepBtn"
        type="primary"
        size="medium"
        >保存设置</el-button
      >
    </div>

    <!-- 添加曝光商品 -->
    <!-- <selectGoodsMonitor
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
    ></selectGoodsMonitor> -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      @transferName="selectGoodsClose"
      :postForm="selectGoodsArr"
      :maxNum="20"
    >
    </selectGoodsMonitor>
    <!-- 指定购买商品 -->
    <!-- <selectGoodsMonitor
      ref="selectGoFilter"
      :isShow="selectGoodsStateFilter"
      @close="selectGoodsCloseFilter"
      :selectGoods="selectGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
    ></selectGoodsMonitor> -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter"
      @transferName="selectGoodsCloseFilter"
      :postForm="selectGoodsFilterArr"
      :maxNum="20"
    >
    </selectGoodsMonitor>

    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 选择奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      :num="1"
      :JingdouCount="JingdouCount"
      @choose-shop="getTheData"
    >
    </selectProduct>
    <!-- 红包雨 选择奖品弹窗 -->
    <selectProduct
      ref="selectProductAward"
      :num="1"
      :JingdouCount="JingdouCount"
      @choose-shop="getTheDataAward"
    >
    </selectProduct>
    <!-- 选择优惠券 -->
    <selectPrize v-model="dialogPrize" @closePrize="closePrize"></selectPrize>
  </div>
</template>

<script>
import selectPrize from "./select_prize.vue";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectProduct from "./select_product";
import QRCode from "qrcodejs2";
// import SelectGoods from "../../components/selectGoodsMonitor";
import { mapState } from "vuex";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";
import {
  getComment,
  editCommentCreate,
  commentCreate,
  splitCouponCreate,
  getSplitCoupon,
  editSplitCoupon,
  redPacketCreate,
  getredPacket,
} from "@/api/paradiseAndTaskCommonController.js";
const prizeName = [
  "",
  "",
  "京豆",
  "实物",
  "店铺积分",
  "淘宝E卡",
  "爱奇艺会员",
  "淘宝PLUS会员",
  "现金红包",
];
export default {
  components: {
    selectProduct,
    selectPrize,
    selectGoodsMonitor,
    draggable,
  },
  computed: {
    ...mapState(["venderType"]),
  },
  watch: {
    theNum(newName, oldName) {
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });

      this.winningRate = this.winningRate.toFixed(3);
    },
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "淘宝E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "淘宝PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "专属商品";
      }
      return result;
    },
    toChinesNum(num) {
      let changeNum = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ]; //changeNum[0] = "零"
      let unit = ["", "十", "百", "千", "万"];
      num = parseInt(num);
      let getWan = (temp) => {
        let strArr = temp.toString().split("").reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
          newNum =
            (i == 0 && strArr[i] == 0
              ? ""
              : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
              ? ""
              : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
            newNum;
        }
        if (num >= 10 && num < 20) {
          newNum = newNum.substring(1, 3);
        }
        return newNum;
      };
      let overWan = Math.floor(num / 10000);
      let noWan = num % 10000;
      if (noWan.toString().length < 4) noWan = "0" + noWan;
      return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    },
  },
  data() {
    return {
      isStartEditTime: "",
      isStartEdit: false,
      valueRow: null,
      isCopy: false,
      statusComment: false,
      localStepNum: 0,
      activityData: {
        id: 132,
      },
      activeValue: null,
      itemId: "",
      backgroundOpacity: false,
      isSave: true,
      stepNum: 1,
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.state.loginUserInfo.expiredIn).valueOf()
          );
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      appraiseValue: "1",
      options: [
        {
          value: "1",
          label: "近7天完成的评价",
        },
        {
          value: "2",
          label: "近15天完成的评价",
        },
        {
          value: "3",
          label: "近1个月完成的评价",
        },
        {
          value: "4",
          label: "近2个月完成的评价",
        },
        {
          value: "0",
          label: "自定义",
        },
      ],
      scores: ["5"],
      labelVal: [
        {
          name: "一星",
          value: "1",
        },
        {
          name: "二星",
          value: "2",
        },
        {
          name: "三星",
          value: "3",
        },
        {
          name: "四星",
          value: "4",
        },
        {
          name: "五星",
          value: "5",
        },
      ],
      winningRate: 0,
      theNum: 0,
      index: 0,
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
      ],
      // 裂变
      dialogPrize: false,
      indexCoupon: 0,
      FissionVoucherList: [
        // 奖项设置
        {
          title: "",
          prizeType: null,
          price: null,
          totalAmount: null,
          quota: "",
          assetsId: "",
          groupNums: "",
          couponType: "",
        },
      ],
      // hongbaoyu
      awardSettingsLsit: [
        {
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          awardMinScore: null,
          awardMaxScore: null,
          awardLevel: null,
        },
      ],
      awardIndex: 0,
      draggingIdFilter: [],
      mainImagelistFilter: [],
      isDraggingFilter: false,
      selectGoodsStateFilter: false,
      itemListForFilter: [],
      selectGoodsFilterArr: [],
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      giftList: [], // 礼包模板
      levelList: [],
      disableTime: false,
      qrcode: null,
      order: "",
      showDialog: false,
      isShow: false,
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.activityStartTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            }
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return (
              time.getTime() > new Date(this.ruleForm.activityEndTime).getTime()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      //下单时间限制
      pickerOrderEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.startCommentTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.startCommentTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleForm.startCommentTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.startCommentTime).getTime()
              );
            }
          } else {
          }
        },
      },
      pickerOrderStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            // return time.getTime() > new Date(this.ruleForm.orderEndTime).getTime();
            const day = 24 * 60 * 60 * 1000 * 60;
            return (
              time.getTime() <
              new Date(this.ruleForm.activityStartTime).getTime() - day
            );
          } else {
          }
        },
      },
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        {
          continueSignPoints: "",
          days: "",
        },
      ],
      itemArrOne: [],
      peopleList: [],
      ruleForm: {
        membershipTime:"",
        //设置规则表单
        activityName: "",
        activityObject: 0,
        newOldCustomer: 0,
        partner: ["-1"],
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        radio: 0,
        startTime: "",
        information: [],
        activityStartTime: "", //活动开始时间
        activityEndTime: "", //活动结束时间
        activityRulesText: "", //生成规则
        // 评价有礼
        condFollow: false, // 是否需要关注店铺
        totalMaxRewardNumber: "", //活动期间最大中奖次数
        oneDayMaxRewardNumber: "", //每人每天最大中奖次数
        startCommentTime: "", //评价开始时间
        endCommentTime: "", //评价结束时间
        commentFilter: "", // 评价内容限制，多个用英文逗号隔开
        wordNum: "", //评价字数限制
        imgNum: "", //评价图片张数限制
        videoNum: "", //评价视频限制
        isCommentFilter: false, //是否勾选过滤条件
        filterType: "0", //过滤商品：0全部商品 1指定商品 2排除商品
        skuIdList: "", //skuId集合，多个，隔开
        //红包雨
        gameTime: "30",
        everyoneWinningNum: "",
        winningNum: "",
        itemList: [], //曝光商品集合
      },
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        activityRulesText: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
      },
      orderCRM: false,
      orderCRMtime: "",
      orderShow: false,
      generalCoupon: [], // 通用优惠券
    };
  },
  created() {
    this.activityData = this.$route.query.activityData;
    this.localStepNum = this.activityData.id;
    console.log("this.$route.query------>", this.$route.query);
    console.log("this.localStepNum------>", this.localStepNum);
    if (this.$route.query.valueRow) {
      this.backgroundOpacity =
        this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.statusComment =
        this.$route.query.statusComment == "true" ? true : false;
      this.isStartEdit = this.$route.query.isStartEdit == "true" ? true : false;
      this.valueRow = this.$route.query.valueRow;
      this.activeValue = this.$route.query.activeValue;
      if (this.activityData.id == 20) this.getCommentEdit();
      if (this.activityData.id == 21) this.getSplitCouponEdit();
      if (this.activityData.id == 22) this.getRedParker();
    } else if (this.$route.query.copyParams) {
      // 复制
      this.isCopy = true;
      this.backgroundOpacity = false;
      this.isSave = true;
      this.statusComment = true;
      this.isStartEdit = false;
      this.valueRow = this.$route.query.copyParams.valueRow;
      this.activeValue = this.$route.query.copyParams.activeValue;
      if (this.activityData.id == 20) this.getCommentEdit();
      if (this.activityData.id == 21) this.getSplitCouponEdit();
      if (this.activityData.id == 22) this.getRedParker();
    } else {
      this.activityTimeChange();
    }
    // 数据初始化
    this.getLevel();
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
    console.log("this.activeValue333------>", this.activeValue);
  },
  mounted() {},
  methods: {
    // 活动进行中修改奖品数量
    beAdd(row) {
      console.log("活动进行中修改奖品数量", row, Number(row.totalAmount));
      if (this.isStartEdit) {
        if (row.minNum && Number(row.totalAmount) < Number(row.minNum)) {
          row.totalAmount = row.minNum;
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    // 修改 评价有礼 数据回显
    getCommentEdit() {
      getComment(this.valueRow.id).then((res) => {
        this.activityTimeValue = [
          String(res.data.startTime),
          String(res.data.endTime),
        ];
        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityStartTime = String(res.data.startTime);
        this.ruleForm.activityEndTime = String(res.data.endTime);
        this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
        // 奖品
        this.ruleForm.condFollow = res.data.condFollow == 1 ? true : false;
        this.ruleForm.isCommentFilter = res.data.ruleDTO.isCommentFilter
          ? true
          : false;
        this.ruleForm.videoNum = res.data.ruleDTO.videoNum;
        this.ruleForm.wordNum = res.data.ruleDTO.wordNum;
        this.ruleForm.imgNum = res.data.ruleDTO.imgNum;
        this.ruleForm.startCommentTime = res.data.ruleDTO.startCommentTime;
        this.ruleForm.oneDayMaxRewardNumber =
          res.data.ruleDTO.oneDayMaxRewardNumber;
        this.ruleForm.endCommentTime = res.data.ruleDTO.endCommentTime;
        this.ruleForm.commentFilter = res.data.ruleDTO.commentFilter;
        this.ruleForm.totalMaxRewardNumber =
          res.data.ruleDTO.totalMaxRewardNumber;
        this.appraiseValue = String(res.data.ruleDTO.timeType);
        this.scores = res.data.ruleDTO.scores.split(",");

        this.ruleForm.filterType = String(res.data.ruleDTO.filterType);
        this.ruleForm.radio = res.data.priceType; // 0：显示淘宝价 1：显示促销价 ,
        // 奖品
        this.prizeSettingList = res.data.integralParadisePrizeDTOS;

        this.prizeSettingList.forEach((item, index) => {
          item.index = index;
          if (item.percentage) {
            this.winningRate += Number(item.percentage);
          }
        });
        this.winningRate = this.winningRate.toFixed(3);
        this.ruleForm.activityObject = res.data.hasOwnProperty("activityObject")
          ? res.data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = res.data.hasOwnProperty("newOldCustomer")
          ? Number(res.data.newOldCustomer)
          : 0;
        this.peopleList =
          res.data.hasOwnProperty("seniorGroupId") &&
          res.data.seniorGroupId.length > 0
            ? res.data.seniorGroupId.split(",")
            : [];
        if (res.data.allowLevel) {
          this.ruleForm.partner = res.data.allowLevel.split(",");
        }
        this.ruleForm.membershipTime = res.data.membershipTime
        // 指定购买商品
        if (res.data.ruleDTO.filterType == 1) {
          this.itemListForFilter = res.data.ruleDTO.itemList.map((item) => {
            return {
              ...item,
              numIid: item.wareId,
              itemTitle: item.title,
              picUrl: item.logo,
            };
          });
          this.selectGoodsFilterArr = this.itemListForFilter;
          this.mainImagelistFilter = this.itemListForFilter;
        }
        //曝光商品
        this.ruleForm.exposureSwitch =
          res.data.isExposureItem == 0 ? false : true;
        // 商品处理
        let shopList = res.data.itemList
          ? res.data.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            })
          : [];
        this.selectGoodsArr = shopList;
        this.mainImagelist = shopList;
        this.itemListFor = shopList;
        this.activityTimeChange();
      });
    },
    // 修改 裂变 数据回显
    getSplitCouponEdit() {
      getSplitCoupon(this.valueRow.id).then((res) => {
        this.activityTimeValue = [
          String(res.data.startTime),
          String(res.data.endTime),
        ];
        if (this.isStartEdit) {
          //进行中活动 无法修改活动开启时间
          this.isStartEditTime = String(res.data.startTime);
        }
        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityStartTime = String(res.data.startTime);
        this.ruleForm.activityEndTime = String(res.data.endTime);
        this.ruleForm.activityObject = res.data.hasOwnProperty("activityObject")
          ? res.data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = res.data.hasOwnProperty("newOldCustomer")
          ? Number(res.data.newOldCustomer)
          : 0;
        this.peopleList =
          res.data.hasOwnProperty("seniorGroupId") &&
          res.data.seniorGroupId.length > 0
            ? res.data.seniorGroupId.split(",")
            : [];
        if (res.data.allowLevel) {
          this.ruleForm.partner = res.data.allowLevel.split(",");
        }
        this.ruleForm.membershipTime = res.data.membershipTime
        if (!this.isCopy) {
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          this.FissionVoucherList = res.data.pointActivityPrizeDTOList;
          this.FissionVoucherList.forEach(
            (item) => (item.minNum = item.totalAmount)
          );
        } else {
          this.ruleForm.activityRulesText = ""; //生成规则
          this.FissionVoucherList = [
            // 奖项设置
            {
              title: "",
              prizeType: null,
              price: null,
              totalAmount: null,
              quota: "",
              assetsId: "",
              groupNums: "",
              couponType: "",
            },
          ];
        }
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.membershipTime = res.data.membershipTime
        // 奖品
        this.ruleForm.radio = res.data.priceType; // 0：显示淘宝价 1：显示促销价 ,
        //曝光商品
        this.ruleForm.exposureSwitch =
          res.data.isExposureItem == 0 ? false : true;
        // 商品处理
        let shopList = res.data.itemList
          ? res.data.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            })
          : [];
        this.selectGoodsArr = shopList;
        this.mainImagelist = shopList;
        this.itemListFor = shopList;
        this.activityTimeChange();
      });
    },
    // 修改 红包雨 数据回显
    getRedParker() {
      getredPacket(this.valueRow.id).then((res) => {
        this.activityTimeValue = [
          String(res.data.startTime),
          String(res.data.endTime),
        ];
        if (this.isStartEdit) {
          //进行中活动 无法修改活动开启时间
          this.isStartEditTime = String(res.data.startTime);
        }
        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityStartTime = String(res.data.startTime);
        this.ruleForm.activityEndTime = String(res.data.endTime);
        this.ruleForm.activityObject = res.data.hasOwnProperty("activityObject")
          ? res.data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = res.data.hasOwnProperty("newOldCustomer")
          ? Number(res.data.newOldCustomer)
          : 0;
        this.peopleList =
          res.data.hasOwnProperty("seniorGroupId") &&
          res.data.seniorGroupId.length > 0
            ? res.data.seniorGroupId.split(",")
            : [];
        if (res.data.allowLevel) {
          this.ruleForm.partner = res.data.allowLevel.split(",");
        }
        this.ruleForm.membershipTime = res.data.membershipTime
        if (!this.isCopy) {
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          this.awardSettingsLsit = res.data.awardSettings;
          this.awardSettingsLsit.forEach(
            (item) => (item.minNum = item.totalAmount)
          );
        } else {
          this.ruleForm.activityRulesText = ""; //生成规则
          this.awardSettingsLsit = [
            {
              prizeType: null,
              price: null,
              title: "",
              totalAmount: null,
              awardMinScore: null,
              awardMaxScore: null,
              awardLevel: null,
            },
          ];
        }
        this.ruleForm.condFollow = res.data.condFollow == 1 ? true : false;
        // 奖品
        this.ruleForm.radio = res.data.priceType; // 0：显示淘宝价 1：显示促销价 ,
        this.ruleForm.gameTime = res.data.rule.gameTime;
        this.ruleForm.everyoneWinningNum = res.data.rule.everyoneWinningNum;
        this.ruleForm.winningNum = res.data.rule.winningNum;
        //曝光商品
        this.ruleForm.exposureSwitch =
          res.data.isExposureItem == 0 ? false : true;
        // 商品处理
        let shopList = res.data.itemList
          ? res.data.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            })
          : [];
        this.selectGoodsArr = shopList;
        this.mainImagelist = shopList;
        this.itemListFor = shopList;
        this.activityTimeChange();
      });
    },
    //清除
    cleanData(row) {
      row.assetsId = null;
      row.prizeType = 9;
      row.price = null;
      row.title = "谢谢参与";
      row.logo = null;
      row.percentage = "";
      row.singleAmount = null;
      row.totalAmount = null;
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      if (row.percentage) {
        this.winningRate = this.winningRate.toFixed(3);
      }
    },
    // 获取奖品
    getTheData(data, prizeType) {
      console.log(data, prizeType, 2233);
      if (this.venderType && prizeType == 1 && data.couponType == 1) {
        return this.$message.warning("此类型奖品暂时不支持自营店铺！");
      }
      if (prizeType == 1) {
        this.prizeSettingList[this.index].couponType = data.couponType;
        this.prizeSettingList[this.index].singleAmount = 1;
        this.prizeSettingList[this.index].quota = data.quota;
      }
      if (prizeType == 2) {
        this.prizeSettingList[this.index].quantityTotal = data.quantityTotal;
      }
      if (data.giftType) {
        this.prizeSettingList[this.index].giftType = Number(data.giftType);
      }
      this.prizeSettingList[this.index].price =
        data.discount || data.singleAmount;

      this.prizeSettingList[this.index].assetsId = Number(data.couponId);
      this.prizeSettingList[this.index].logo = data.logo;
      if (prizeType == 10) {
        this.prizeSettingList[this.index].logo = data.picUrl;
      }
      this.prizeSettingList[this.index].prizeType = prizeType;
      if (prizeType == 4) {
        this.prizeSettingList[this.index].title = data.discount + "店铺积分";
      } else {
        this.prizeSettingList[this.index].title =
          data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      }
      if (data.singleAmount) {
        this.prizeSettingList[this.index].singleAmount = data.singleAmount;
      }
      console.log(this.prizeSettingList, 123);
    },
    // 保留小数点后两位
    oninput2(val) {
      // debugger
      if (val < 0) {
        val = "";
      } else if (val > 100) {
        val = "100";
      }

      let winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
      });

      if (winningRate > 100) {
        val = String(100 - (winningRate - val));
      } else if (winningRate == 100) {
        if (val >= 100) {
          val = "100";
        } else {
          val = String(100 - (winningRate - val));
          if (val == 0) {
            val = "";
          }
        }
      }
      // if (val == 0) {
      //   val = "";
      // }
      val = val.substring(0, 10);

      this.theNum++;
      return val ? val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3") : "";
    },
    //选择奖品弹窗
    centerVis(row) {
      this.$refs.selectProduct.openDialog();
      this.JingdouCount.prizeCount = row.totalAmount;
      this.index = row.index;

      console.log("this.JingdouCount.prizeCount", this.JingdouCount.prizeCount);
      this.$refs.selectProduct.physicalGift(row)
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      const url = `${this.activityData.telCode}&activityType=${this.activityData.id}`;
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 117, // 设置宽度，单位像素
          height: 117, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url,
        });
      }
    },
    // 裂变  奖品确定
    closePrize(val, params) {
      if (val) {
        if (this.venderType && val.couponType == 1) {
          return this.$message.warning("此类型奖品暂时不支持自营店铺！");
        }
        let isflay = false;
        this.FissionVoucherList.forEach((item) => {
          if (item.assetsId === params.couponId) {
            isflay = true;
          }
        });
        if (isflay) {
          return this.$message.warning("你已选用该优惠券，请重新选择");
        }
        this.FissionVoucherList[this.indexCoupon].quota = params.quota;
        this.FissionVoucherList[this.indexCoupon].conditions =
          params.conditions;
        this.FissionVoucherList[this.indexCoupon].prizeType = 1;
        if (params.couponType == 4) {
          this.FissionVoucherList[this.indexCoupon].assetsId = null;
          this.FissionVoucherList[this.indexCoupon].batchKey = params.batchKey;
        } else {
          this.FissionVoucherList[this.indexCoupon].assetsId = params.couponId;
        }
        this.FissionVoucherList[this.indexCoupon].couponType =
          params.couponType;
        if (params.couponType == 4) {
          this.FissionVoucherList[this.indexCoupon].price = params.price;
          this.FissionVoucherList[this.indexCoupon].title = "优惠券";
        } else {
          this.FissionVoucherList[this.indexCoupon].price =
            params.discount || params.singleAmount;
          this.FissionVoucherList[this.indexCoupon].title =
            params.name.length >= 12
              ? params.name.substring(0, 12)
              : params.name;
        }
      }
      this.dialogPrize = false;
    },
    // 裂变  选择奖品
    selectCoupon(index) {
      if (this.isStartEdit) return;
      this.dialogPrize = true;
      this.indexCoupon = index;
    },
    // 裂变  添加优惠券
    addCoupon() {
      if (this.isStartEdit) return;
      this.FissionVoucherList.push({
        title: "",
        prizeType: null,
        price: null,
        totalAmount: null,
        quota: "",
        assetsId: "",
        groupNums: "",
        couponType: "",
      });
    },
    // 裂变  清空  删除
    deleteaCoupon(item, num = "2") {
      if (this.isStartEdit) return;
      // 1为清空
      if (num === "1") {
        item.title = "";
        item.prizeType = null;
        item.price = "";
        item.totalAmount = "";
        item.assetsId = "";
        item.quota = "";
        item.groupNums = "";
        item.couponType = "";
      } else {
        this.FissionVoucherList.splice(item, 1);
      }
    },
    // 红包雨  弹框
    getTheDataAward(data, prizeType) {
      if (data.couponType == 4) {
        this.generalCoupon.push(JSON.parse(JSON.stringify(data)));
      }
      if (this.venderType && prizeType == 1 && data.couponType == 1) {
        return this.$message.warning("此类型奖品暂时不支持自营店铺！");
      }

      if (prizeType == 1) {
        if (data.couponType == 4) {
          this.awardSettingsLsit[this.awardIndex].batchKey = data.batchKey;
        }
        this.awardSettingsLsit[this.awardIndex].couponType = data.couponType;
        this.awardSettingsLsit[this.awardIndex].singleAmount = 1;
        this.awardSettingsLsit[this.awardIndex].quota = data.quota;
      }
      if (prizeType == 2) {
        this.awardSettingsLsit[this.awardIndex].quantityTotal =
          data.quantityTotal;
      }
      if (data.giftType) {
        this.awardSettingsLsit[this.awardIndex].giftType = Number(
          data.giftType
        );
      }
      if (data.couponType == 4) {
        this.awardSettingsLsit[this.awardIndex].price = data.price;
      } else {
        this.awardSettingsLsit[this.awardIndex].price =
          data.discount || data.singleAmount;
      }

      this.awardSettingsLsit[this.awardIndex].assetsId = Number(data.couponId);
      this.awardSettingsLsit[this.awardIndex].logo = data.logo;
      if (prizeType == 10) {
        this.awardSettingsLsit[this.awardIndex].logo = data.picUrl;
      }
      this.awardSettingsLsit[this.awardIndex].prizeType = prizeType;
      if (prizeType == 4) {
        this.awardSettingsLsit[this.awardIndex].title =
          data.discount + "店铺积分";
      } else {
        // 通用优惠券
        if (this.generalCoupon.length != 0) {
          this.awardSettingsLsit[this.awardIndex].title = "优惠券";
        } else {
          // 专属商品
          if (prizeType == 10) {
            this.awardSettingsLsit[this.awardIndex].title =
              data.itemTitle.length >= 12
                ? data.itemTitle.substring(0, 12)
                : data.itemTitle;
            this.awardSettingsLsit[this.awardIndex].price = data.price;
            this.awardSettingsLsit[this.awardIndex].assetsId = data.id;
            this.awardSettingsLsit[this.awardIndex].logo = data.picUrl;
          } else {
            this.awardSettingsLsit[this.awardIndex].title =
              data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
          }
        }
      }
      if (data.singleAmount) {
        this.awardSettingsLsit[this.awardIndex].singleAmount =
          data.singleAmount;
      }
    },
    // 红包雨
    selectPacket(index, item) {
      if (this.isStartEdit) return;
      this.generalCoupon = [];
      this.$refs.selectProductAward.openDialog();
      this.JingdouCount.prizeCount = item.totalAmount;
      this.awardIndex = index;
      this.$refs.selectProductAward.physicalGift(item)
    },
    // 添加优惠券
    addPacket() {
      if (this.isStartEdit) return;
      this.awardSettingsLsit.push({
        prizeType: null,
        price: null,
        title: "",
        totalAmount: null,
        awardMinScore: null,
        awardMaxScore: null,
        awardLevel: null,
      });
    },
    // 清空  删除
    deletePacket(item, num = "2") {
      if (this.isStartEdit) return;
      // 1为清空
      if (num === "1") {
        item.prizeType = null;
        item.price = null;
        item.title = "";
        item.totalAmount = "";
        item.awardMinScore = null;
        item.awardMaxScore = null;
        item.awardLevel = "";
      } else {
        this.awardSettingsLsit.splice(item, 1);
      }
    },
    //模板下一步
    nextStepKai(items) {
      // console.log(items);
      //新增判断
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
      this.$emit("titopName", this.activityData.name, true);
    },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = null;
      this.ruleForm.activityEndTime = null;
    },
    clearOrderTime() {
      if (this.isSave) {
        this.ruleForm.startCommentTime = null;
        this.ruleForm.endCommentTime = null;
      }
    },
    //删除
    delec(item, index) {
      let i = -1;
      this.mainImagelist.forEach((items, index1) => {
        if (items.skuId == item.skuId) i = index1;
      });
      if (i != -1) {
        this.mainImagelist.splice(i, 1);
        this.itemListFor = this.mainImagelist;
        // this.itemListFor.splice(i, 1);
      }

      console.log(this.mainImagelist, 4444444);
    },
    delecFilter(item, index) {
      let i = -1;
      this.mainImagelistFilter.forEach((items, index1) => {
        if (items.skuId == item.skuId) i = index1;
      });
      if (i != -1) {
        this.mainImagelistFilter.splice(i, 1);
        this.itemListForFilter = this.mainImagelistFilter;
        // this.itemListForFilter.splice(index, 1);
      }

      console.log(this.mainImagelist, 4444444);
    },
    // 参与商品删除
    // delecFilter(index) {
    //   this.mainImagelistFilter.splice(index, 1);
    //   this.itemListForFilter.splice(index, 1);
    // },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    // 参与商品图片拖拽
    onEndFilter() {
      this.isDraggingFilter = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelistFilter.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingIdFilter = arr;
      });
    },
    //活动时间驱动
    activityTimeChange(val) {
      if (this.isStartEdit) {
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0] = this.isStartEditTime;
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let commentStart = new Date(this.ruleForm.startCommentTime).valueOf();
      let invalidateDate = new Date(
        this.$store.state.loginUserInfo.expiredIn
      ).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart =
        this.ruleForm.activityStartTime &&
        this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd =
        this.ruleForm.activityEndTime &&
        this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime && this.ruleForm.activityStartTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }
      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      const day = 86400000 * 60;
      if (start - commentStart > day && commentStart && start) {
        this.ruleForm.startCommentTime = "";
        this.$message.warning("评价开始时间最小范围在活动时间的前60天");
      }
      if ((start - nowTime) / 1000 / 60 < 5) {
        if (this.activeValue) {
          this.disableTime = true;
        } else {
          this.$message.warning("活动时间开始时间要大于当前时间的5分钟");
          this.activityTimeValue[0] = "";
          this.ruleForm.activityStartTime = null;
          return;
        }
      }
      if (end < nowTime && end) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (end < start && start && end) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }
    },
    // 评价规则判断
    orderChange() {
      let start = new Date(this.ruleForm.startCommentTime).valueOf();
      let end = new Date(this.ruleForm.endCommentTime).valueOf();
      let activityStartTime = new Date(
        this.ruleForm.activityStartTime
      ).valueOf();
      if (start > end && start && end) {
        this.$message.warning("评价开始时间不能大于评价结束时间");
        this.ruleForm.startCommentTime = null;
        return;
      }
      const day = 86400000 * 60;
      if (activityStartTime - start > day && activityStartTime && start) {
        this.ruleForm.startCommentTime = "";
        this.$message.warning("评价开始时间最小范围在活动时间的前60天");
      }
      if (
        Number(this.ruleForm.oneDayMaxRewardNumber) >
          Number(this.ruleForm.totalMaxRewardNumber) &&
        this.ruleForm.totalMaxRewardNumber &&
        this.ruleForm.oneDayMaxRewardNumber
      ) {
        this.ruleForm.totalMaxRewardNumber = "";
        this.$message.warning("活动期间每人每天中奖次数不能大于累计中奖次数");
      }
      if (
        Number(this.ruleForm.everyoneWinningNum) >
          Number(this.ruleForm.winningNum) &&
        this.ruleForm.everyoneWinningNum &&
        this.ruleForm.winningNum
      ) {
        this.ruleForm.winningNum = "";
        this.$message.warning("活动期间每人每天中奖次数不能大于累计中奖次数");
      }
    },
    // 返回上一步
    returnBack() {
      this.$emit("returnBack");
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      this.joinBlackList = true;
      // this.$emit("saveEdit");
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      // 评价
      let cardParams = {
        membershipTime:this.ruleForm.membershipTime,
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        condFollow: this.ruleForm.condFollow ? 1 : 0, //是否需要关注店铺
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0, //是否添加曝光商品 0 否 1 是
        priceType: this.ruleForm.radio, //  0：显示淘宝价 1：显示促销
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
        ruleDTO: {
          totalMaxRewardNumber: this.ruleForm.totalMaxRewardNumber, //近X天内未购
          oneDayMaxRewardNumber: this.ruleForm.oneDayMaxRewardNumber,
          startCommentTime:
            this.appraiseValue == "0" ? this.ruleForm.startCommentTime : "",
          endCommentTime:
            this.appraiseValue == "0" ? this.ruleForm.endCommentTime : "",
          timeType: this.appraiseValue, //评价时间类型  0自定义 1近七天 2近15天 3近1个月 4 近2个月
          scores: this.scores.join(","),
          wordNum: this.ruleForm.wordNum,
          imgNum: this.ruleForm.imgNum,
          videoNum: this.ruleForm.videoNum,
          isCommentFilter: this.ruleForm.isCommentFilter ? 1 : 0,
          commentFilter: this.ruleForm.commentFilter,
          filterType: this.ruleForm.filterType,
          skuIdList:
            this.ruleForm.filterType == "0"
              ? ""
              : this.itemListForFilter.map((item) => {
                  return {
                    logo: item.logo,
                    jdPrice: item.price,
                    skuName: item.title,
                    skuId: item.skuId,
                    wareId: item.numIid,
                  };
                }),
        }, //活动名称
        itemList: this.itemListFor.map((item) => {
          return {
            logo: item.logo,
            price: item.price,
            title: item.title,
            skuId: item.skuId,
            wareId: item.numIid,
          };
        }), //曝光商品集合
        integralParadisePrizeDTOS: [],
      };
      cardParams.integralParadisePrizeDTOS = this.prizeSettingList.map(
        (item) => {
          let prize = {
            ...item,
            percentage: item.percentage ? item.percentage : 0,
          };
          if (prize.prizeType == 1) {
            prize.quota = item.quota;
            prize.couponType = item.couponType;
            prize.singleAmount = 1;
          } else if (prize.prizeType == 8) {
            prize.singleAmount = 1;
          } else {
            prize.singleAmount = item.price;
          }
          return prize;
        }
      );
      // 裂变
      let SplitCouponActivityDTO = {
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0, //是否添加曝光商品 0 否 1 是
        activityObject: this.ruleForm.activityObject,
        membershipTime:this.ruleForm.membershipTime,
        newOldCustomer: this.ruleForm.newOldCustomer,
        seniorGroupId: this.peopleList.join(","),
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
        priceType: this.ruleForm.radio, //  0：显示淘宝价 1：显示促销
        itemList: this.itemListFor.map((item) => {
          return {
            logo: item.logo,
            price: item.price,
            title: item.title,
            skuId: item.skuId,
            wareId: item.numIid,
          };
        }), //曝光商品集合
        pointActivityPrizeDTOList: this.FissionVoucherList,
      };
      // 红包雨
      let redParams = {
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        condFollow: this.ruleForm.condFollow ? 1 : 0, //是否需要关注店铺
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0, //是否添加曝光商品 0 否 1 是
        priceType: this.ruleForm.radio, //  0：显示淘宝价 1：显示促销
        activityObject: this.ruleForm.activityObject,
        membershipTime:this.ruleForm.membershipTime,
        newOldCustomer: this.ruleForm.newOldCustomer,
        seniorGroupId: this.peopleList.join(","),
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
        itemList: this.itemListFor.map((item) => {
          return {
            logo: item.logo,
            price: item.price,
            title: item.title,
            skuId: item.skuId,
            wareId: item.numIid,
          };
        }), //曝光商品集合
        rule: {
          gameTime: this.ruleForm.gameTime,
          everyoneWinningNum: this.ruleForm.everyoneWinningNum,
          winningNum: this.ruleForm.winningNum,
        },
        awardSettings: [],
      };

      redParams.awardSettings = this.awardSettingsLsit.map((item, index) => {
        let prize = {
          ...item,
          awardLevel: index + 1,
        };
        if (prize.prizeType == 1) {
          // if(prize.couponType == 4) {
          //   prize.batchKey =
          // }
          prize.quota = item.quota;
          prize.couponType = item.couponType;
          prize.singleAmount = 1;
        } else if (prize.prizeType == 8) {
          prize.singleAmount = 1;
        } else {
          // prize.singleAmount = item.price;
          prize.singleAmount = parseInt(item.price * 1);
        }
        return prize;
      });
      // console.log(cardParams);
      //对象排序(根据对象的某一属性)
      if (this.draggingId.length != []) {
        let a = this.draggingId;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListFor.find((obj) => {
            // if (obj.wareId == a[i]) {
            //   b.push({
            //     logo: obj.logo,
            //     price: obj.price,
            //     title: obj.title,
            //     wareId: obj.wareId,
            //   });
            // }
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
                wareId: obj.numIid,
              });
            }
          });
        }
        cardParams.itemList = b;
        SplitCouponActivityDTO.itemList = b;
        redParams.itemList = b;
      }

      //指定商品对象排序(根据对象的某一属性)
      if (this.draggingIdFilter.length != []) {
        let a = this.draggingIdFilter;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListForFilter.find((obj) => {
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
                wareId: obj.numIid,
              });
            }
          });
        }
        cardParams.ruleDTO.skuIdList = b;
      }

      //活动名称的限制
      if (
        !this.ruleForm.activityName ||
        this.ruleForm.activityName.length == 0
      ) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      if (this.activityData.id == 20) {
        if (this.ruleForm.partner.length == 0) {
          this.$message.warning("活动参与对象不能为空");
          return;
        }
        //请填写评价时间！
        if (
          (!this.ruleForm.startCommentTime || !this.ruleForm.endCommentTime) &&
          this.appraiseValue == "0"
        ) {
          this.$message.warning("请填写评价时间！");
          return;
        }
        //请填写评星设置
        if (this.scores.length === 0) {
          this.$message.warning("请填写评星设置");
          return;
        }
        //请填写过滤条件
        if (this.ruleForm.isCommentFilter) {
          if (!this.ruleForm.commentFilter) {
            this.$message.warning("请填写过滤条件");
            return;
          }
        }
        if (this.ruleForm.filterType == 1) {
          if (this.itemListForFilter.length == 0) {
            this.$message.warning("请添加参与商品！");
            return;
          }
        }
        // // 请将奖品填写完整！
        let isFlay = false;
        this.prizeSettingList.forEach((item) => {
          if (item.prizeType != 9) {
            if (
              !item.price ||
              !item.percentage ||
              !item.totalAmount ||
              !item.title
            ) {
              isFlay = true;
            }
          }
        });
        if (isFlay) {
          return this.$message.warning("请将奖品填写完整！");
        }
      }
      if (this.activityData.id == 21) {
        // // 请将奖品填写完整！
        let isFlay = false;
        this.FissionVoucherList.forEach((item) => {
          if (!item.groupNums || !item.totalAmount || !item.title) {
            isFlay = true;
          }
        });
        if (isFlay) {
          return this.$message.warning("请将奖项填写完整1！");
        }
      }
      if (this.activityData.id == 22) {
        // // 请将奖品填写完整！
        let isFlay = false;

        this.awardSettingsLsit.forEach((item) => {
          if (
            !item.totalAmount ||
            item.awardMinScore == null ||
            !item.awardMaxScore ||
            item.price == null ||
            !item.title
          ) {
            isFlay = true;
          }
        });
        if (isFlay) {
          return this.$message.warning("请将奖项填写完整2！");
        }
      }

      //请添加曝光商品！
      if (this.ruleForm.exposureSwitch) {
        if (this.itemListFor.length === 0) {
          this.$message.warning("请添加曝光商品！");
          return;
        }
      }
      //活动规则不能为空
      if (!this.ruleForm.activityRulesText) {
        this.$message.warning("活动规则不能为空");
        return;
      }
      //判断勾选提示后即可调取接口
      if (this.checked == true) {
        if (this.activityData.id == 20) {
          if (this.valueRow) {
            editCommentCreate({ ...cardParams, id: this.valueRow.id }).then(
              (res) => {
                if (res.code == 1) {
                  this.$message.success(res.message);
                  // this.$emit("saveEdit");
                  this.$router.push({ path: "activeList1" });
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          } else {
            commentCreate(cardParams).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.message);
                // this.$emit("saveEdit");
                this.$router.push({ path: "activeList1" });
              } else {
                this.$message.error(res.message);
              }
            });
          }
        }
        if (this.activityData.id == 21) {
          if (this.valueRow && !this.isCopy) {
            editSplitCoupon({
              ...SplitCouponActivityDTO,
              id: this.valueRow.id,
            }).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.message);
                // this.$emit("saveEdit");
                this.$router.push({ path: "activeList" });
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            splitCouponCreate({ ...SplitCouponActivityDTO }).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.message);
                // this.$emit("saveEdit");
                this.$router.push({ path: "activeList" });
              } else {
                this.$message.error(res.message);
              }
            });
          }
        }

        if (this.activityData.id == 22) {
          if (this.valueRow && !this.isCopy) {
            redPacketCreate({
              ...redParams,
              activityId: this.valueRow.id,
            }).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.message);
                // this.$emit("saveEdit");
                this.$router.push({ path: "activeList" });
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            redPacketCreate({ ...redParams }).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.message);
                // this.$emit("saveEdit");
                this.$router.push({ path: "activeList" });
              } else {
                this.$message.error(res.message);
              }
            });
          }
        }

        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let oldValue = this.ruleForm;
      let text1 = "",
        text2 =
          this.ruleForm.filterType == "0"
            ? "2、全部商品评价参与；"
            : "2、部分商品评价参与；",
        text3 =
          "3、单个订单中包含几款商品则可获几次抽奖机会，虚拟商品无法获得抽奖机会；",
        text4 =
          "4、奖品数量有限，先到先得，如果是实物奖项，请及时填写地址便于奖品发放；",
        text5 =
          "5、平台需要对评价内容进行审核，如果没有获得参与机会，请检查订单的评价状态，耐心等待；",
        text6 = "奖品发放形式：",
        text7 = "实物奖：",
        text8 =
          "  （1）中奖客户信息收集：页面弹屏提示中奖客户提供收货地址、号码和奖项；",
        text9 =
          "  （2）实物奖采取寄送方式发放，获奖用户需在开奖后填写姓名、联系电话、详细地址信息。如因用户原因无法联系上，即奖品作废不再补发，或如用户未填写真实有效的信息或填写收货信息不详，均视为放弃奖品；",
        text10 = "虚拟产品奖：",
        text11 = "  （1）京豆：中奖后系统预计24小时内自动发放至账户；",
        text12 = "  （2）优惠券：中奖后需手动领取，预计24小时到账；",
        text13 = "6、是否中奖以活动发布者后台统计结果为准；",
        text14 =
          "7、若用户存在刷奖等恶意行为，一经发现将取消抽奖资格（如奖品已经发放，有权追回奖品）；",
        text15 = "8、【活动参与主体资格】",
        text16 =
          "  （1）每位自然人用户仅能使用一个淘宝账号参与活动，微信号、QQ、淘宝帐号、手机号码等任一信息一致或指向同一用户的，视为同一个用户，则第一个参与本活动的账号参与结果有效，其余账号参与结果均视为无效。",
        text17 =
          "  （2）若发现同一位用户使用不同账号重复参与活动，承办方有权取消其获奖资格。";
            //活动时间
      let text34 = ""
      if (this.ruleForm.activityObject == "1" && this.ruleForm.membershipTime && this.ruleForm.partner!=[0]){
        text34 = `入会时间：${this.ruleForm.membershipTime}之后入会的会员可参与活动`
      }
      let Arr1 = [];
      if (this.activityData.id == 20) {
        //活动时间
        if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
          text1 =
            "1、活动时间：" +
            this.ruleForm.activityStartTime +
            "~" +
            this.ruleForm.activityEndTime +
            ";";
        }
        Arr1 = [
          text1,
          text2,
          text3,
          text4,
          text5,
          text34,
          text6,
          text7,
          text8,
          text9,
          text10,
          text11,
          text12,
          text13,
          text14,
          text15,
          text16,
          text17,
        ];
      }
      if (this.activityData.id == 21) {
        //活动时间
        if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
          text1 =
            "1、活动时间：" +
            this.ruleForm.activityStartTime +
            "~" +
            this.ruleForm.activityEndTime +
            ";";
        }
        text2 = "2、按照成团人数要求完成组队；";
        text3 = "3、活动期间，同一优惠，用户只能为一位好友助力；";
        text4 = "4、同一优惠，同一用户最多只能享受一次；";
        text5 = "5、优惠券数量有限，先到先得；";
        // text6 = "注：优惠券发放形式：";
        // text7 = "  (1）领取型优惠券：中奖后需手动领取，预计24小时到账；";
        // text8 = "  (2）发放型优惠券：中奖后无需手动领取，系统自动发放至中奖账户；";
        text6 = "【活动参与主体资格】";
        text7 =
          "  (1）每位自然人用户仅能使用一个淘宝账号参与活动，微信号、QQ、淘宝帐号、手机号码等任一信息一致或指向同一用户的，视为同一个用户，则第一个参与本活动的账号参与结果有效，其余账号参与结果均视为无效；";
        text8 =
          "  (2）若发现同一位用户使用不同账号重复参与活动，承办方有权取消其参与资格";
        text9 = "【注意事项】";
        text10 =
          "  (1）活动过程中，凡以不正当手段（如作弊领取、恶意套取、刷信誉、虚假交易、扰乱系统、实施网络攻击等）参与本次活动的用户，商家有权终止其参与活动，并取消其参与资格（如优惠已发放，商家有权追回），如给商家造成损失的，商家将保留向违规用户继续追索的权利；";
        text11 =
          "  (2）如遇不可抗力(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动中奖名单大批量出错，活动不能正常进行的)，商家有权取消、修改或暂停本活动；";
        text12 = "  (3）是否获得优惠以活动发布者后台统计结果为准。";
        Arr1 = [
          text1,
          text2,
          text3,
          text4,
          text5,
          text34,
          text6,
          text7,
          text8,
          text9,
          text10,
          text11,
          text12,
          text13,
          text14,
          text15,
        ];
      }
      if (this.activityData.id == 22) {
        if (this.ruleForm.activityName) {
          text1 = `1、活动名称：${this.ruleForm.activityName};`;
        }
        if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
          text2 =
            "2、活动时间：" +
            this.ruleForm.activityStartTime +
            "~" +
            this.ruleForm.activityEndTime +
            ";";
        }
        if (this.ruleForm.gameTime) {
          text3 = "3、游戏时间：" + this.ruleForm.gameTime + "秒;";
        }
        if (this.ruleForm.winningNum || this.ruleForm.everyoneWinningNum) {
          text4 = `4、游戏时间：活动期间每人每天中奖不超过${this.ruleForm.everyoneWinningNum}次，累计中奖不超过${this.ruleForm.winningNum}次;`;
        }
        text5 = "5、奖品有限，先到先得。";
        Arr1 = [text1, text2, text3, text4, text5,text34];
      }
      let newText = "";
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + item + "\n";
        }
      });
      this.ruleForm.activityRulesText = newText;
    },
    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    //指定购买商品商品弹窗
    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      // console.log(this.itemListFor);
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
        this.mainImagelistFilter = [];
      }
      // console.log(this.selectGoodsFilterArr, this.itemListForFilter);
      this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsStateFilter = false;
        return;
      }
    },
    selectGoodsClose(event, index) {
      // if (data) {
      //   this.itemListFor = [];
      //   this.mainImagelist = [];
      //   data.forEach((value, index) => {
      //     let fomeVaule = {};
      //     fomeVaule.skuId = data[index].skuId;
      //     fomeVaule.logo = data[index].logo;
      //     fomeVaule.price = data[index].jdPrice || data[index].price;
      //     fomeVaule.title = data[index].wareTitle || data[index].title;
      //     this.itemListFor.push(fomeVaule);
      //     this.mainImagelist.push(fomeVaule);
      //   });
      //   this.selectGoodsArr = this.itemListFor;
      // }
      if (typeof event != "boolean") {
        let newArr = event;
        // event.forEach((item) => {
        //   newArr.push(item.numIid);
        // });
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }
      this.selectGoodsState = false;
    },
    //选择商品数据 曝光
    selectGoodsCloseFilter(event, index) {
      console.log(data, 11111);
      // if (data) {
      //   this.itemListForFilter = [];
      //   this.mainImagelistFilter = [];
      //   data.forEach((value, index) => {
      //     let fomeVaule = {};
      //     fomeVaule.skuId = data[index].skuId;
      //     fomeVaule.logo = data[index].logo;
      //     fomeVaule.price = data[index].jdPrice || data[index].price;
      //     fomeVaule.title = data[index].wareTitle || data[index].title;
      //     this.itemListForFilter.push(fomeVaule);
      //     this.mainImagelistFilter.push(fomeVaule);
      //   });
      //   this.selectGoodsFilterArr = this.itemListForFilter;
      // }
      if (typeof event != "boolean") {
        let newArr = event;
        // event.forEach((item) => {
        //   newArr.push(item.numIid);
        // });
        if (index && index == 1) {
          this.itemListForFilter = newArr;
          this.mainImagelistFilter = newArr;
          this.selectGoodsFilterArr = newArr;
        }
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsStateFilter = false;
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    //输入框限制负数
    checkputn(e, num = "-1", type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.replace(/^0|[^\d]/g, "");
        e = Number(filtered);
        if (num == "0") {
          if (e < 1) {
            e = "";
          }
        }
        if (num == "1") {
          if (e > 9) {
            e = "";
          }
          if (this.ruleForm.imgNum == 9) {
            this.ruleForm.videoNum = "";
          }
        }
        if (num == "2") {
          if (e > 1) {
            e = "";
          }
        }
        if (num == "5") {
          if (e < 2 || e > 5) {
            e = "";
          }
        }
        return e;
      } else {
        if (num.quantityTotal && num.price && num.totalAmount) {
          let numTotal = this.$jingdouTotal({
            ...num,
            prizeCount: num.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return num.totalAmount;
        }
      }
    },
    //输入正数、一个小数点
    checkputnPositive(e) {
      e.target.value = e.target.value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/[^\d.]/g, "");
      let filtered = e.target.value;
      if (Number(filtered) < 1) {
        e.target.value = "";
      }
    },
    //曝光商品
    exposureChange(val) {
      if (val == "0") {
        this.ruleForm.exposureSwitch = false;
        this.itemListFor = [];
      } else {
        this.ruleForm.exposureSwitch = true;
      }
    },
    clickLocalStep() {
      sessionStorage.setItem("goBack", this.activityData.goIndex);
      if (this.$route.query.copyParams && this.$route.query.copyParams.isCopy) {
        sessionStorage.setItem("goBackCopy", true);
      }
      this.$router.go(-1);
      // if (this.backgroundOpacity) {
      //   this.$emit("returnBack");
      //   return;
      // }
      // this.localStep = 0;
      // this.localStepNum = 0;
      // this.ruleForm.radio = 0;
      // this.ruleForm.exposureSwitch = false;
      // this.itemListFor = [];
      // this.ruleForm.activityName = "";
      // this.ruleForm.activityStartTime = "";
      // this.ruleForm.activityEndTime = "";
      // this.selectGoodsStateFilter = false;
      // this.itemListForFilter = [];
      // this.selectGoodsFilterArr = [];
      // this.ruleForm.condFollow = false; // 是否需要关注店铺
      // this.awardIndex = 0;
      // this.draggingIdFilter = [];
      // this.mainImagelistFilter = [];
      // this.isDraggingFilter = false;
      // this.selectGoodsStateFilter = false;
      // this.itemListForFilter = [];
      // this.selectGoodsFilterArr = [];
      // this.ruleForm.filterType = "0"; //过滤商品：0全部商品 1指定商品 2排除商品
      // this.ruleForm.skuIdList = []; //skuId集合，多个，隔开
      // this.mainImagelist = []; //图片拖拽排序
      // this.isDragging = false;
      // this.itemListFor = []; //商品弹框选择商品数据
      // this.selectGoodsState = false; //曝光商品弹窗
      // this.ruleForm.activityRulesText = "";
      // this.$emit("titopName", this.activityData.name, false);
    },
    handleCreate() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch",
        "_self"
      );
    },
    // 组队人数是发放的N倍
    multiple(num, num1, index, row) {
      if (!num) {
        this.$message.warning("请先填写组队人数！");
        this.FissionVoucherList[index].totalAmount = "";
      } else {
        if (Number(num1) % Number(num) != 0) {
          this.$message.warning(
            "发放人数必须为组队人数的N倍，以确保奖品发放顺利；"
          );
          this.FissionVoucherList[index].totalAmount = "";
        } else {
          this.beAdd(row);
        }
      }
    },
    // 区间递减
    scoreChange(item, index) {
      if (index != 0) {
        const num = Number(this.awardSettingsLsit[index - 1].awardMinScore);
        if (Number(item.awardMaxScore) >= num) {
          this.awardSettingsLsit[index].awardMaxScore = "";
          this.$message.warning("奖项设置分数必须是递减的，且区间不能重复；");
          return;
        }
      }
      if (
        (Number(item.awardMaxScore) <= Number(item.awardMinScore) &&
          item.awardMinScore &&
          item.awardMaxScore) ||
        item.awardMaxScore == 0
      ) {
        this.awardSettingsLsit[index].awardMaxScore = "";
        this.$message.warning("奖项设置最大分数必须大于最小分数");
      }
    },
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner = ["-1"];
      this.peopleList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.inputcount {
  /deep/.el-input__count {
    display: none !important;
  }
}
.dataPicker {
  /deep/.el-button--text {
    display: none !important;
  }
}

/deep/ .el-table__body-wrapper {
  // overflow: visible !important;
  overflow: auto;
}
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}

.termAdd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  color: #333;
  p {
    margin: 0;
  }
  .add {
    margin-left: 4px;
    color: #2670fb;
  }
}
.s {
  color: #2670fb;
  cursor: pointer;
}
.tips {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  box-sizing: border-box;
  padding: 13px 30px;
  background: #fffaee;
  font-size: 13px;
  color: #333;
  img {
    display: inline-block;
    float: left;
    position: absolute;
    width: 14px;
    height: 14px;
    color: #ffffff;
    margin: 9px 4px 0 3px;
  }
  i {
    color: #fe8f8a;
    opacity: 0.7;
  }
  p {
    margin: 0;
    line-height: 20px;
    padding-left: 18px;
  }
}
.set {
  display: inline-block;
  margin-top: 30px;
}
.overHiddle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 2px;
  width: 96%;
  border: none;
  text-align: left;
  display: inline-block;
  margin-left: -8px;
  &:hover,
  &:focus {
    color: #666;
    background: #fff;
  }
}
.orangeColor {
  color: #2670fb;
}
.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
//
// .wrapperBg {
//   background-color: #666 !important;
// }
.giftBottom {
  position: absolute;
  bottom: 19%;
  left: 50%;
  transform: translateX(-50%);
  // background: red;
  width: 112px;
  height: 24px;
  display: block;
  text-align: center;
  line-height: 24px;
  color: red;
  opacity: 0.7;
  font-weight: 600;
}
.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #cccccc;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #cccccc;
  font-size: 12px;
  font-weight: normal;
  margin-left: 6px;
  &:hover {
    border: 1px solid #2670fb;
    color: #2670fb;
  }
}
.rule_box {
  width: 860px;
  // height: 217px;
  margin-top: 9px;

  background: #f4f7ff;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;

  &_middle {
    padding-top: 10px;
  }
  &_content {
    padding: 0 15px;
    img {
      display: inline-block;
      float: left;
      position: absolute;
      width: 14px;
      height: 14px;
      color: #ffffff;
      margin: 9px 4px 0 3px;
    }
    p {
      padding-left: 21px;
    }
  }
}
.shopDiaog {
  width: 60px;
  height: 26px;
  background: #ffffff;
  display: inline-block;
  line-height: 26px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #000;
  &:hover {
    border: 1px solid #2670fb;
    color: #2670fb;
  }
}
.tooltipBox {
  box-sizing: border-box;
  height: 485px;
  // width: 100%;
  // height: 100%;
  // background: red;
  // box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
  padding: 30px;
  display: inline-flex;
  &-left {
    width: 253px;
    height: 417px;
    position: relative;
    margin-right: 30px;
    // .tooltipheis {
    //   width: 128px;
    //   height: 417px;
    //   position: absolute;
    //   border: 2px dashed #666666;
    //   top: 0px;
    //   left: -50%;
    // }
    .tooltipBoder {
      width: 184px;
      height: 273px;
      position: absolute;
      border: 2px dashed #2fd461;
      top: 50%;
      left: 46%;
      transform: translate(-50%, -50%);
      border-radius: 4px;
      &::after {
        content: "";
        width: 53px;
        border-top: 2px dashed #2fd461;
        display: block;
        position: absolute;
        right: -55px;
        top: 25px;
      }

      &::before {
        content: "";
        width: 16px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -63px;
        top: 88px;
      }
    }
    .tooltipliji {
      position: absolute;
      bottom: 80px;
      left: 47%;
      transform: translateX(-50%);
      width: 154px;
      height: 42px;
      border: 2px dashed #75baff;
      border-radius: 4px;
      &::before {
        content: "";
        width: 50px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -55px;
        top: 19px;
      }
      &::after {
        content: "";
        height: 150px;
        border-right: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -60px;
        top: -131px;
      }
    }
  }
  &-right {
    width: 368px;
    height: 100%;
    .p1 {
      font-size: 15px;
      font-weight: 500;
      line-height: 21px;
      color: #333333;
    }
    .p2 {
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      color: #666666;
    }
  }
}
.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.crowd {
  padding-left: 50px;
  margin-bottom: 20px;
  &-point {
    color: #999999;
    margin-bottom: 8px;
    position: relative;
    padding-left: 8px;
    &::before {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 3px;
      height: 14px;
      background: #2670fb;
      border-radius: 3px;
      content: "";
      display: block;
    }
  }
  &-tab {
    width: 100%;
    &-head {
      width: 100%;
      height: 48px;
      padding-left: 30px;
      background: #fafafa;
    }
    &-sm {
      display: inline-block;
      width: 87%;
      color: #666;
      // line-height: 48px;
      position: relative;
    }
    &-name {
      display: inline-block;
      width: 13%;
      line-height: 48px;
    }
    &-middle {
      padding-left: 30px;
      border: 1px solid #f0f0f0;
      border-left: none;
      border-right: none;
      display: flex;
    }
    .descbox {
      // top: -8px;
      display: flex;
      justify-items: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .dx {
      // position: absolute;
      // top: 19px;
      width: 100%;
    }
    .nameAlign {
      display: flex;
      height: 48px;
      align-items: center;
    }
  }
}
.card-point {
  width: 100%;
  background: #f4f7ff;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    // width: 60px;
    background: url("../../assets/thdImg/pages/waringBule.svg") no-repeat;
    background-size: 20px 20px;
    margin-top: 1px;
    margin-right: 5px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #2670fb;
  }
  color: #999;
}

.delectPosible:hover {
  -webkit-box-shadow: #ccc 0px 1px 1px;
  -moz-box-shadow: #ccc 0px 1px 1px;
  box-shadow: #ccc 0px 1px 1px;
}
.flex {
  display: flex;
  align-items: center;
}

.add_btn1 {
  cursor: pointer;
  color: #2670fb;
  border: 1px solid #2670fb;
  width: 94px;
  height: 32px;
  display: flex;
  border-radius: 4px;
  background: rgba(38, 112, 251, 0.1);
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  &:hover {
    background: #2670fb;
    color: #fff;
  }
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  height: 88.5vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
      margin-left: 11%;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .tishi {
      // height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      background: #fffaee;
      border-radius: 4px;
      margin-bottom: 20px;
      padding: 14px 20px;
    }
    .itemList {
      display: flex;
      .item {
        width: 100%;
        flex: 1;
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          // width: 100%;
          height: 100%;
          width: 253px;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #2670fb;
            border-bottom: 1px solid #2670fb;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #2670fb;
            border-left: 1px solid #2670fb;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        .wrapper-kaika {
          width: 100%;
          height: 100%;
          display: grid;
          // align-items: center;
          // justify-content: center;

          &-img {
            background-color: #fafafa;
            border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
            border-radius: 8px;
            height: 350px;
            // margin-right: 20px;
            position: relative;
            &:hover {
              .borderkaika::before,
              .borderkaika::after {
                opacity: 1;
                transform: scale(1);
              }
            }
            .borderkaika {
              position: absolute;
              left: -6px;
              top: -6px;
              width: 218px;
              height: 360px;
              border-radius: 4px;
              &::before,
              &::after {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                content: "";
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.8s, transform 0.8s;
                border-radius: 4px;
              }
              &::before {
                border-top: 1px solid #2670fb;
                border-bottom: 1px solid #2670fb;
                -webkit-transform: scale(0, 1);
                transform: scale(0, 1);
              }
              &::after {
                border-right: 1px solid #2670fb;
                border-left: 1px solid #2670fb;
                -webkit-transform: scale(1, 0);
                transform: scale(1, 0);
              }
            }

            div {
              font-size: 18px;
              font-weight: bold;
              // line-height: 25px;
              color: #333333;
            }
            img {
              width: 32px;
              height: 32px;
            }

            .queryIdIMG {
              display: none;
            }
            &:hover {
              .queryIdIMG {
                display: block;
              }
              .mask {
                opacity: 1;
              }
            }
            .mask {
              display: flex;
              flex-direction: column;
              justify-content: center;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              background-color: rgba(0, 0, 0, 0.6);
              color: #fff;
              opacity: 0;
              transition: all 0.2s;
              .img {
                max-width: 130px;
                margin: 0 auto 30px;
                .imgBg {
                  box-sizing: border-box;
                  height: 129px;
                  width: 129px;
                  padding: 6px;
                  border-radius: 6px;
                  background-color: #fff;
                }
                .tpl {
                  display: inline-block;
                  font-size: 14px;
                  color: #fff;
                  margin-top: 10px;
                  // opacity: 0.7;
                }
              }
            }
          }
          &-tanchuang {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .lijijq {
            &::after {
              content: "立即领取";
              display: block;
              position: absolute;
              bottom: 9px;
              left: 51%;
              transform: translateX(-50%);
              font-size: 14px;
              font-family: system-ui;
              font-weight: bold;
              color: #ed6e09;
              text-shadow: 0 0 black;
            }
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          display: grid;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
          }
          .mask {
            width: 240px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    // min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    // margin-bottom: 29px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38, 112, 251, 0.1);
      border: 1px solid #2670fb;
      color: #2670fb;
      border-radius: 4px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url(../../assets/images/integralCenter/yhq.png);
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .discount_sty {
          font-family: DIN;
          font-weight: bold;
          color: #2670fb;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 280px;
          height: 120px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #2670fb;
      transition: all 0.2s;
      &:hover {
        background-color: #2670fb;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #2670fb;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }

  .wrapper-kaika-img {
    width: 210px;
    height: 374px;
    margin-bottom: 40px;
  }
}
@media (min-width: 1080px) and (max-width: 1319px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1320px) and (max-width: 1589px) {
  .wrapper-kaika {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1590px) and (max-width: 1899px) {
  .wrapper-kaika {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (min-width: 1900px) {
  .wrapper-kaika {
    grid-template-columns: repeat(7, 1fr);
  }
}
</style>
